import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_PETITION_SIGNER_RECEIPT_WELCOME_CONFIG = defineFcm('lcm_petition_signer_receipt_welcome_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description:
			'LCM config for petition_signer_receipt_welcome message. Defines which country codes route petition_signer_receipt_welcome messages to Iterable',
		template: {
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	});
